import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import classnames from 'classnames';
import Spinner from 'components/loader';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import styles from '../styles.scss';

export default class CustomModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      closing: false,
      overlayClose: true,
      cornerClose: true,
      actions: [
        {
          label: 'Close',
          style: 'flat',
          onClick: this.close,
          title: props.title,
          close: true
        }
      ],
      title: props.title,
      classes: {},
      onClose: () => {}
    };
  }

  close = () => {
    // for animation
    this.setState({ closing: true });
    this.state.onClose();
    setTimeout(this.props.closeModal, 300);
  };

  setActions = actions => {
    this.setState({ actions });
  };

  setTitle = title => {
    this.setState({ title });
  };

  setOnClose = onClose => {
    this.setState({ onClose });
  };

  setOverlayClose = overlayClose => {
    this.setState({ overlayClose });
  };

  setCornerClose = cornerClose => {
    this.setState({ cornerClose });
  };

  renderActions = () => {
    return this.state.actions.map(action => {
      let onClick;
      if (action.onClick && !action.close) {
        onClick = action.onClick;
      } else if (action.onClick && action.close) {
        onClick = () => {
          let click = action.onClick();
          if (click && click.then) {
            click.then(() => {
              this.close();
            });
          } else {
            this.close();
          }
        };
      } else if (action.close) {
        onClick = this.close;
      }

      if (action.style === 'raised') {
        return (
          <RaisedButton
            label={action.label}
            primary={true}
            onClick={onClick}
            disabled={action.disabled}
          />
        );
      } else {
        return (
          <FlatButton
            label={action.label}
            primary={true}
            onClick={onClick}
            disabled={action.disabled}
          />
        );
      }
    });
  };

  toggleModalClasses = classes => {
    this.setState({ classes: Object.assign({}, this.state.classes, classes) });
  };

  render() {
    return (
      <div>
        <Dialog
          contentClassName={classnames(
            this.props.className,
            this.state.classes,
            styles.materialModal,
            styles.customModal,
            {
              [styles.modalLg]: this.props.size === 'lg',
              [styles.modalSm]: this.props.size === 'sm'
            }
          )}
          overlayClassName={styles.modalOverlay}
          onRequestClose={this.close}
          title={this.state.title}
          modal={!this.state.overlayClose}
          open={!this.state.closing}
          autoScrollBodyContent={true}
          actions={this.renderActions()}
          actionsContainerClassName={classnames(styles.modalActions)}>
          <Spinner type="modal" />
          {React.createElement(this.props.component, {
            ...this.props,
            closeModal: this.close,
            setActions: this.setActions,
            setOnClose: this.setOnClose,
            setOverlayClose: this.setOverlayClose,
            setTitle: this.setTitle,
            toggleModalClasses: this.toggleModalClasses,
            setCornerClose: this.setCornerClose
          })}
          {this.state.cornerClose && !!this.state.title && (
            <CloseIcon className={styles.modalClose} onClick={this.close} />
          )}
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/customModal/index.js